export const createSnapshotSchedules = (snapshotSchedulesClient) => {
    return new SnapshotSchedulesImpl(snapshotSchedulesClient);
};
class SnapshotSchedulesImpl {
    snapshotSchedules;
    constructor(snapshotSchedules) {
        this.snapshotSchedules = snapshotSchedules;
    }
    create(schedule) {
        return this.snapshotSchedules.create(schedule);
    }
    delete(label) {
        return this.snapshotSchedules.delete(label);
    }
    list() {
        return this.snapshotSchedules.list();
    }
}
